import BaseApi from "@/core/HttpResources/BaseApi";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import UserResearchCenter from '@/models/security/userResearchCenter.Model';
export default class LanguageLabelService {
  baseApiPublish = new BaseApi("LanguageLabel");


  async searchLanguageByName(centerName:string): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "Get",
        "SearchByName/" + centerName,
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}